import { Box } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import AnalyticsFilterCard from "./AnalyticsFilterCard";
import AnalyticsKpiCards from "./AnalyticsKpiCards";
import LeadScoreDistributionChart from "./LeadScoreDistributionChart";
import IncomeByBrandChart from "./IncomeByBrandChart";
import LeadsByDayChart from "./LeadsByDayChart";
import LeadsByBrandChart from "./LeadsByBrandChart";
import AnalyticsSkeleton from "./AnalyticsSkeleton";

interface AnalyticsProps {
  data: LeadsManagementData;
}

export default function Analytics({ data }: AnalyticsProps) {
  return (
    <Box sx={{ mt: 2 }}>
      <AnalyticsFilterCard data={data} />

      {data.isLoading ? (
        <AnalyticsSkeleton />
      ) : (
        <>
          <AnalyticsKpiCards data={data} />
          <Box sx={{ display: "grid", gridTemplateColumns: "1.15fr 1fr", gap: 2.5, mt: 2.5 }}>
            <LeadScoreDistributionChart data={data} />
            <IncomeByBrandChart data={data} />
          </Box>
          <LeadsByDayChart data={data} />
          <LeadsByBrandChart data={data} />
        </>
      )}
    </Box>
  );
}
